import { isFunction } from 'lodash';

export default function useLabel(label: string | Function) {
  return isFunction(label) ? (label as Function)() : label;
}
